import { Grid } from '@material-ui/core'
import styled from 'styled-components'

export const GridContainer = styled(Grid)``
